// extracted by mini-css-extract-plugin
export default {"root":"QbkiHN6WcPyg0qp7JHWp"};